import { isGigPaused } from '../gigStatus';
import { isLoggedInUser } from '../isLoggedInUser';
import {
    ALLOWED_CURRENT_USER_STATUS, ALLOWED_CATEGORIES,
    ALLOWED_SUB_CATEGORIES, RESTRICTED_GIG_STATUS
} from '../../components/PackagesTabs/CustomOrderTab/config';

export const inAllowedCategory = ({categoryId, subCategoryId, inCustomOrderPackageTest}) =>
    inCustomOrderPackageTest ||
    !(!ALLOWED_CATEGORIES.includes(categoryId) && !ALLOWED_SUB_CATEGORIES.includes(subCategoryId));

export const shouldRenderCustomOrder = ({
    customOrder,
    general,
    currentUser,
    inCustomOrderPackageTest = false
}) => {
    const {
        gigStatus,
        isStudio,
        categoryId,
        subCategoryId,
        traffiqed,
        isOnVacation
    } = general;
    const { currentUserStatus, allowCustomOrders } = customOrder;
    const isAllowedCurrentUserStatus = ALLOWED_CURRENT_USER_STATUS === currentUserStatus;

    return inAllowedCategory({categoryId, subCategoryId, inCustomOrderPackageTest}) &&
        isAllowedCurrentUserStatus &&
        !RESTRICTED_GIG_STATUS.includes(gigStatus) &&
        allowCustomOrders &&
        !isGigPaused(gigStatus, traffiqed) &&
        !isStudio &&
        isLoggedInUser(currentUser) &&
        !isOnVacation;
};
